<template>
  <div
    class="flex-wrapper"
    :class="{
      'flex-wrapper--inline': inline,
      'grow': grow,
      'grow-children': growChildren,
      'fill': fill,
    }"
    :style="{
      display: inline ? 'inline-flex' : 'flex',
      flexDirection: direction,
      justifyContent,
      alignItems,
      gap: getGap,
      flexWrap: wrap,
      ...(placeItems && { placeItems }),
    }"
  >
    <slot />
  </div>
</template>

<script>
// Inspired by: https://github.com/NotSoSolo/vue3-flex/blob/master/src/Flex.vue

export default {
	props: {
		inline: { type: Boolean, default: false },
		direction: { type: String, default: 'initial' },
		justifyContent: { type: String, default: 'initial' },
		alignItems: { type: String, default: 'initial' },
		placeItems: { type: String, default: undefined },
		gap: { type: [String, Number], default: 'initial' },
		gapUnit: { type: String, default: 'spacer' },
		wrap: { type: String, default: 'nowrap' },
		grow: { type: Boolean, default: false },
		fill: { type: Boolean, default: false },
		growChildren: { type: Boolean, default: false }
	},
	computed: {
		getGap () {
			if (this.gapUnit === 'spacer') {
				return `var(--spacer-${this.gap})`;
			}

			if (this.gapUnit === 'var') {
				return `var(${this.gap})`;
			}

			return `${this.gap}${this.gapUnit}`;
		}
	}
};
</script>

<style>
:root {
  --spacer-xsmall: 0.25rem;
  --spacer-small: 0.5rem;
  --spacer-medium: 1rem;
  --spacer-large: 1.5rem;
  --spacer-xlarge: 2rem;
}

.grow-children > * {
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: 0;
}

.flex-wrapper.fill::after {
  content: "";
  flex: auto;
}
</style>
